// extracted by mini-css-extract-plugin
export var projectContainer = "GridTextProjectElement-module--projectContainer--1PIb-";
export var hashtags = "GridTextProjectElement-module--hashtags--11tPm";
export var awardsContainer = "GridTextProjectElement-module--awardsContainer--2hNC9";
export var description = "GridTextProjectElement-module--description--oY9LT";